import { Navigate, Outlet, useLocation } from "react-router-dom";

import { ROUTES } from "@/constants/routes";
import { authSnapshot } from "@/store/auth";

/**
 * The signed-in gate. Replaces the `beforeLoad` redirect the file-based routes
 * carried: with a data router the check has to be an element, so it sits above
 * every layout that requires a session and hands the attempted URL to the sign-in
 * screen as `?redirect=`, exactly as the old `search: { redirect }` did.
 */
const PrivateRoute = () => {
  const location = useLocation();
  if (!authSnapshot().accessToken) {
    const back = `${location.pathname}${location.search}`;
    return <Navigate to={`${ROUTES.LOGIN}?redirect=${encodeURIComponent(back)}`} replace />;
  }
  return <Outlet />;
};

export default PrivateRoute;
